import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./designInstruction.png"

const 固有の仕様書_設計指示書 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { designInstruction: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"固有の仕様書※\n・設計指示書"}
      src={img}
      helpURL={HELP_LINKS["固有の仕様書・設計指示書"]}
    >
      <RadioGroup
        name={estimateField.designInstruction.key}
        selectedValue={values.designInstruction}
        onChange={handlers.radio}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["固有の仕様書・設計指示書"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["固有の仕様書・設計指示書"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.designInstruction}>
        <p>※配置・配線の制約／禁止領域、デバイスのデザインガイドを参照</p>
      </OneClickFieldMessages>
    </OneClickField>
  )
}

export default 固有の仕様書_設計指示書
